import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const subscriptionbandSlice = createSlice({
  name: "subscriptionband",
  initialState,
  // reducers: {},
});

// export const { userLoggedIn, userLoggedOut } = userSlice.actions
export default subscriptionbandSlice.reducer;
